<template>
	<span class="float-right  ml-3">
		<b-link
			v-if="section.Editable"
			
			@click.prevent="saveArraySection"
			title="Save"
		>
			<b-icon
				font-scale="1.5"
				icon="check-square"
                variant="success"
			></b-icon>
		</b-link>

		<b-link
			v-else		
			@click.prevent="editArraySection"
			title="Edit"
		>
			<b-icon
				font-scale="1.5"
				icon="pencil-square"
			></b-icon>
		</b-link>

	</span>
</template>

<script>
export default {
	name: "SaveOrEditButtonsRow",

	props: ["section", "returnData"],

	methods: {
		editArraySection() {
			// set the editable property of the passed section to true
            this.$set(this.section, "Editable", true);

            this.$emit("edit");		
		},
		saveArraySection() {
			// set the editable property of the passed section to false
			this.$set(this.section, "Editable", false);
			// do a save
			this.$emit("save");		
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/partials/save-or-edit-buttons-row.vue